import constants from "../config/constants";
import { postRequest } from "../libs/AxiosService.util";

export async function serviceGetUpdatedIdCardList(params) {
  return await postRequest("employees/id/card/list/updated", params);
}
export async function serviceDownloadUpdatedEmpsIdCards (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"employees/id/card/csv/updated", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
      ...(constants.CLIENT_TOKEN ? { 'x-client-token': constants.CLIENT_TOKEN } : {}),
    },
    body: JSON.stringify({
      ...params
    }),
  });
}